import { render, staticRenderFns } from "./ManpowerChart.vue?vue&type=template&id=4106712e&"
import script from "./ManpowerChart.vue?vue&type=script&lang=js&"
export * from "./ManpowerChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports